<template>
    <div class="yq-duration-picker" v-bind="$attrs">
        <el-input v-model.number="parsedValue.amount" @input="onInput"
                  :size="size" type="number"></el-input>
        <el-select class="yq-duration-picker-unit-select"
                   v-model="parsedValue.unit" @input="onInput" :size="size">
            <el-option v-for="item in timeUnits" :key="item.value" :label="item.label"
                       :value="item.value"></el-option>
        </el-select>
    </div>
</template>

<script>
    import moment from 'moment'
    import dateUtils from '../../service/date-utils'

    export default {
        name: "DurationPicker",
        props: {
            value: String,
            size: {
                type: String,
                default: 'mini'
            },
            standard: {
                type: String,
                default: 'JAVA_TIME_DURATION'
            },
            defaultTimeUnit: {
                type: String,
                default: 'hours'
            }
        },
        inheritAttrs: false,
        data() {
            return {
                parsedValue: dateUtils.parseDateTimeInterval(this.value, this.defaultTimeUnit)
            }
        },
        watch: {
            value(newValue) {
                const oldValue = this.format(this.parsedValue)
                if (oldValue === newValue) {
                    return
                }
                this.parsedValue = dateUtils.parseDateTimeInterval(newValue, this.defaultTimeUnit)
            },
        },
        computed: {
            timeUnits(){
                return this.standard === 'JAVA_TIME_DURATION' ? dateUtils.timeUnitsForDateTimeJavaTimeDuration :
                    dateUtils.timeUnitsForDateTime
            }
        },
        methods: {
            format(value) {
                if (!value.amount) {
                    return null
                }
                const duration = moment.duration(value.amount, value.unit)
                return duration.toISOString()
            },
            onInput() {
                if (this.parsedValue.amount !== null && this.parsedValue.amount !== undefined &&
                    this.parsedValue.amount !== '') {
                    if (this.parsedValue.amount < 1) {
                        this.parsedValue.amount = 1
                    } else {
                        this.parsedValue.amount = Number(Number(this.parsedValue.amount).toFixed(0))
                    }
                }
                this.$emit('input', this.format(this.parsedValue))
            }
        }
    }
</script>
